import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";
import { Organization } from '@models/organization.model';
import { Emr } from '@models/emr.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationDetailsService {

  private apiUrl = environment.apiUrl;

  createNewOrganization(organizationData: any) {
    return this.http.post<Organization[]>(`${this.apiUrl}/Organization/create`, organizationData);
  }

  getOrganizationDetails(orgId: any): Observable<any> {
    return this.http.get<Organization[]>(`${this.apiUrl}/Organization/` + orgId);
  }

  updateOrganizationDetails(details: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/Organization/update`, details);
  }

  updateOrganizationEMRDetails(details: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/Organization/update/EMR`, details);
  }

  addOrganizationEMR(details: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/Organization/EMR`, details);
  }

  getEmrs(): Observable<Emr[]> {
    return this.http.get<Emr[]>(`${this.apiUrl}/Organization/Emr`);
  }

  deleteOrganizationEMR(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Organization/EMR/${id}`);
  }

  addSupplementalSystem(details: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/Organization/SupplementalSystem`, details);
  }

  updateSupplementalSystem(details: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/Organization/update/SupplementalSystem`, details);
  }

  deleteSupplementalSystem(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/Organization/SupplementalSystem/${id}`);
  }

    // Disable organization
  disableOrganization(organizationId: string): Observable<void> {
    return this.http.get(`${this.apiUrl}/organization/Disable/${organizationId}`, {
      responseType: 'text',
    }).pipe(
      map(() => void 0)
    );
  }

  // Enable organization
  enableOrganization(organizationId: string): Observable<void> {
    return this.http.get(`${this.apiUrl}/organization/Enable/${organizationId}`, {
      responseType: 'text',
    }).pipe(
      map(() => void 0)
    );
  }

  setTestOrganizationStatus(orgId: string, isTestOrganization: number): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/organization/${orgId}/test-status`,
      { isTestOrganization }
    );
  }

  updateOrganizationACOStatus(orgId: string, isMemberOfACO: number): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/organization/${orgId}/aco-status`,
      { isMemberOfACO }
    );
  }

  constructor(private http: HttpClient) { }
}
